import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/modules/Astro/Compatibility/Zodiac/index.tsx")